import { mdiPlus /*mdiMagnify*/ } from "@mdi/js";
import Icon from "@mdi/react";

export default function Table({
  columns,
  data = [],
  title,
  onAdd,
  onEdit,
  onDelete,
  searchTerm,
  onSearchChange,
  isSearching,
  onClearSearch,
}) {
  // Function to trigger browser's native search bar (CTRL+F)
  // const triggerSearch = () => {
  //   const event = new KeyboardEvent("keydown", {
  //     key: "f",
  //     code: "KeyF",
  //     keyCode: 70,
  //     which: 70,
  //     ctrlKey: true, // Simulates CTRL key
  //     bubbles: true,
  //     cancelable: true,
  //   });

  //   document.dispatchEvent(event);
  // };

  return (
    <div className="table-responsive">
      {/* Header Section */}
      <div className="row align-items-center mb-3 mx-5">
        {/* Title Column */}
        <div className="col-6">
          <h2>{title}</h2>
        </div>

        {/* Action Buttons */}
        <div className="col-6 text-end d-flex justify-content-end align-items-center gap-2">
          {/* Search Field */}
          {onSearchChange && (
            <div className="position-relative">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar (mínimo 3 caracteres)..."
                value={searchTerm || ""}
                onChange={onSearchChange}
                style={{ minWidth: "300px", paddingRight: searchTerm ? "60px" : "12px" }}
              />
              {isSearching && (
                <div className="position-absolute top-50 translate-middle-y" style={{ right: searchTerm ? "35px" : "10px" }}>
                  <div className="spinner-border spinner-border-sm text-secondary" role="status">
                    <span className="visually-hidden">Buscando...</span>
                  </div>
                </div>
              )}
              {searchTerm && onClearSearch && (
                <button
                  className="btn btn-link position-absolute top-50 translate-middle-y"
                  style={{ right: "5px", padding: "0 5px" }}
                  onClick={onClearSearch}
                  title="Limpar busca"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              )}
            </div>
          )}

          {/* Add Button */}
          {onAdd && (
            <button className="btn btn-success" onClick={onAdd}>
              <Icon path={mdiPlus} size={1} color="white" />
            </button>
          )}
        </div>
      </div>

      {/* Table Section */}
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index} scope="col">
                {column.label}
              </th>
            ))}
            {(onEdit || onDelete) && <th scope="col"></th>}
          </tr>
        </thead>

        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => (
                <td key={colIndex}>
                  {column.render
                    ? column.render(row) // If column has render function, use it
                    : getValueByPath(row, column.field)}
                </td>
              ))}

              {/* Actions */}
              {(onEdit || onDelete) && (
                <td>
                  {onEdit && (
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => onEdit(row)}
                    >
                      Editar
                    </button>
                  )}

                  {onDelete && (
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => onDelete(row)}
                    >
                      Deletar
                    </button>
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function getValueByPath(obj, path) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}
